module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-button pointer",
    class: _vm.classes,
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('a', {
    staticClass: "btn-back"
  }, [_vm._v(_vm._s(_vm.$t('checkout.title_back')))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7019b093!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/_partials/back-button.vue
// module id = 264
// module chunks = 1